import { Deserializable } from '../../protocols/deserializable';

export class Gender implements Deserializable {
  id!: number;
  name!: string;

  onDeserialize() {}
}
